<div class="slide-canvas">
  <div
    class="main"
    role="dialog"
    aria-modal="false"
    [attr.id]="name"
    [class.out]="isSlideOutTabOpen"
    (appClickOutside)="close($event)"
  >
    <div class="container" *ngIf="isSlideOutTabOpen" [cvFocusTrap]="isSlideOutTabOpen">
      <button #closeButton class="icon close-icon" (click)="close()">
        <img src="/assets/images/board/close.svg" alt="{{ CLOSE_STRING | translateString : lang }}" />
      </button>
      <ng-content></ng-content>
    </div>
  </div>
</div>
